module.exports = __webpack_public_path__ + "static/1.2.B.4 CASA MERCEA - PLAN DE SITUATIE-c3f017079a559d52e4e0b138cde002cd.jpg";